export default __webpack_public_path__ + "static/PromptIconSeven-29b2f226729c4b8464854fb96f1fa7c3.png";